import { createContext } from 'react';

export type SearchContextProps = {
  openDialog: () => void;
  setValue: (value: string) => void;
  searchValue?: string;
};

export const SearchContext = createContext<SearchContextProps>({
  openDialog: () => {},
  setValue: () => {},
  searchValue: undefined,
});
